import { render, staticRenderFns } from "./MatchingDialog.vue?vue&type=template&id=f38867da"
import script from "./MatchingDialog.vue?vue&type=script&lang=js"
export * from "./MatchingDialog.vue?vue&type=script&lang=js"
import style0 from "./MatchingDialog.vue?vue&type=style&index=0&id=f38867da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports